var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvMagnavoxStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 14.1603V1.77778H5.37386L7.86777 8.7815L10.3356 1.78646H14.6281V12.4137L14.5847 14.3254H11.3522V7.66055L8.92786 14.308H6.87715L4.28768 7.7822V14.1603H1.33325Z",
    fill: "#ED1A2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvMagnavoxStore);
export default __webpack_public_path__ + "static/media/ctv_magnavox_store.4c0cf30a9965e89ea8a0f0275608550a.svg";
export { ForwardRef as ReactComponent };